import { Component, Input } from '@angular/core';


@Component({
  selector: 'ui-badge',
  standalone: true,
  imports: [],
  templateUrl: './ui-badge.component.html',
  styleUrl: './ui-badge.component.scss'
})
export class UiBadgeComponent {
  @Input() variant: 'primary' | 'secondary' | 'accent' | 'info' | 'success' | 'warning' | 'error' | 'neutral' = 'primary';
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() outline = false;
  @Input() className = '';

  get computedClasses(): string {
    const classes = ['badge'];

    // Variant
    if (this.outline) {
      classes.push(`badge-outline`);
    }
    classes.push(`badge-${this.variant}`);

    // Size
    if (this.size === 'sm') {
      classes.push('badge-sm');
    } else if (this.size === 'lg') {
      classes.push('badge-lg');
    }

    return [...classes, this.className].join(' ');
  }
}

